import 'magnific-popup';

class LightboxTrigger {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        let counter = '%curr% of %total%';
        if (document.documentElement.lang === 'de') {
            counter = '%curr% von %total%';
        }

        let gallery = $(this.elem).closest('.ce-gallery');
        if (!gallery.length) {
            gallery = $(this.elem).closest('.news-img-wrap');
        }

        if (gallery.length) {
            gallery.magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true,
                    tCounter: counter,
                },
                closeBtnInside: false,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>&#215;</span></button>',
            });

            return;
        }

        const slider = $(this.elem).closest('.slider');

        if (slider.length) {
            slider.magnificPopup({
                delegate: '.slick-slide:not(.slick-cloned) a',
                type: 'image',
                callbacks: {
                    elementParse: (item) => {
                        if (item.src.includes('youtube') || item.src.split('.').pop() === 'mp4') {
                            item.type = 'iframe';
                        }
                    },
                },
                gallery: {
                    enabled: true,
                    tCounter: counter,
                },
                closeBtnInside: false,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>&#215;</span></button>',
            });

            return;
        }

        $(this.elem).magnificPopup({
            type: 'image',
            closeBtnInside: false,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>&#215;</span></button>',
        });
    }
}

export default LightboxTrigger;
